<template>
    <v-select
        :model-value="modelValue"
        :items="items"
        item-title="text"
        item-value="value"
        :label="label"
        density="compact"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>

<script>
export default {
    name: "FleetTruckSelect",
    props: {
        modelValue: {
            type: [Number, String],
            default: null,
        },
        items: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            default: undefined,
        },
    },
    emits: ["update:modelValue"],
};
</script>
